import styled from 'styled-components';

import { styledScroll } from 'styles/styledScroll';
import colors from 'themes/Main';

const {
  white,
  gray03,
  gray01,
  darkBlue,
  success,
  danger,
  warning,
  gray06,
} = colors;

export const Form = styled.form`
  margin-top: 32px;
`;

export const ModalWrap = styled.div`
  z-index: 100;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: fill-available;
  background: rgba(0, 0, 0, 0.75);
`;

export const ModalContainer = styled.div`
  z-index: 0;
  min-width: 320px;
  max-width: 600px;
  margin: 0 20px;
  max-height: fill-available;
  background: ${white};
  border-radius: 10px;
  box-shadow: 0px 7px 8px rgba(0, 0, 0, 0.2), 0px 5px 22px rgba(0, 0, 0, 0.12),
    0px 12px 17px rgba(0, 0, 0, 0.14);
  padding: 32px;
  transition: all 0.25s ease;
  overflow-x: hidden;

  ${styledScroll};
`;

export const ModalBody = styled.div`
  color: ${gray03};
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
`;

export const ColWrap = styled.div`
  width: calc(50% - 8px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 16px;
`;

export const ColFullWrap = styled(ColWrap)`
  display: block;
  width: 100%;
  margin-top: 16px;
`;

export const FakeLabel = styled.div`
  cursor: default;
  font-size: 12px;
  font-weight: 700;
  color: ${darkBlue};
  width: 100%;
`;

export const InfoText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${gray01};
  width: 100%;
  height: 100%;
  line-height: 21px;
  ${styledScroll};
`;

export const ModalButtonsWrap = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;

  button:nth-child(2) {
    margin-left: 16px;
  }
`;

export const ModalAlert = styled.div`
  cursor: default;
  width: fit-content;
  padding: 8px;
  border-radius: 4px;
  background: ${({ type }) => {
    switch (type) {
      case 'success':
        return success;
      case 'danger':
        return danger;
      case 'warning':
        return warning;
      default:
        return darkBlue;
    }
  }};
  color: ${white};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
`;

export const ProjectMore = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover > div {
    display: block;
  }
`;

export const MoreActions = styled.div`
  z-index: 20;
  display: none;
  position: absolute;
  top: 0px;
  right: -30px;
  min-width: 180px;
  border-radius: 5px;
  box-shadow: 0px 4px 5px rgba(215, 220, 230, 0.2),
    0px 3px 14px rgba(215, 220, 230, 0.12),
    0px 8px 10px rgba(215, 220, 230, 0.14);
  background-color: ${white};
  transition: all 0.1s ease-out;
  margin-bottom: 64px;
`;

export const MoreActionsHeader = styled.p`
  cursor: context-menu;
  text-align: left;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: ${gray03};
  padding: 16px 16px 0;
`;

export const MoreActionsTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 12px;
  flex-wrap: wrap;
`;
export const MoreActionsTableHeader = styled.div`
  width: fill-available;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  padding: 4px 0;
  border-bottom: 1px solid ${gray06};

  div {
    color: ${gray01} !important;
    font-weight: 700;
    width: 90px;
    text-align: center;
    &:nth-child(1) {
      width: 120px;
      text-align: left;
    }
  }
`;

export const MoreActionsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 0;
  width: fill-available;
`;

export const MoreActionsIncoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MoreActionsIcon = styled.svg`
  width: 18px;
  height: 18px;
  margin-left: 12px;
  path {
    fill: ${darkBlue};
  }
`;

export const InfoStrong = styled.strong`
  color: ${darkBlue};
  font-weight: 700;
  width: 120px;
`;

export const InfoSpan = styled.span`
  color: ${gray01};
  font-weight: 400 !important;
  width: 90px;
  text-align: center;
`;
